module.exports = __webpack_public_path__ + "media/images/dashboard/payment/master-card-ea8e0c6ef59f85972c16d8e16fd182e3.jpeg";